/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SubscribeIndexRouteImport } from './routes/subscribe/index'
import { Route as RecordIndexRouteImport } from './routes/record/index'
import { Route as ProfileIndexRouteImport } from './routes/profile/index'
import { Route as HomeIndexRouteImport } from './routes/home/index'
import { Route as CheckedoutIndexRouteImport } from './routes/checkedout/index'
import { Route as UploadingAssetIdRouteImport } from './routes/uploading/$assetId'
import { Route as SubmissionSubmissionIdRouteImport } from './routes/submission/$submissionId'
import { Route as ReviewReviewIdRouteImport } from './routes/review/$reviewId'
import { Route as PubsubmissionSubmissionIdRouteImport } from './routes/pubsubmission/$submissionId'
import { Route as MessageActivityIdRouteImport } from './routes/message/$activityId'
import { Route as LeaderboardCompetitionIdRouteImport } from './routes/leaderboard/$competitionId'
import { Route as DraftsubmissionSubmissionIdRouteImport } from './routes/draftsubmission/$submissionId'
import { Route as DraftcompetitionCompetitionIdRouteImport } from './routes/draftcompetition/$competitionId'
import { Route as CompetitionCompetitionIdRouteImport } from './routes/competition/$competitionId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscribeIndexRoute = SubscribeIndexRouteImport.update({
  id: '/subscribe/',
  path: '/subscribe/',
  getParentRoute: () => rootRouteImport,
} as any)
const RecordIndexRoute = RecordIndexRouteImport.update({
  id: '/record/',
  path: '/record/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileIndexRoute = ProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeIndexRoute = HomeIndexRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckedoutIndexRoute = CheckedoutIndexRouteImport.update({
  id: '/checkedout/',
  path: '/checkedout/',
  getParentRoute: () => rootRouteImport,
} as any)
const UploadingAssetIdRoute = UploadingAssetIdRouteImport.update({
  id: '/uploading/$assetId',
  path: '/uploading/$assetId',
  getParentRoute: () => rootRouteImport,
} as any)
const SubmissionSubmissionIdRoute = SubmissionSubmissionIdRouteImport.update({
  id: '/submission/$submissionId',
  path: '/submission/$submissionId',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewReviewIdRoute = ReviewReviewIdRouteImport.update({
  id: '/review/$reviewId',
  path: '/review/$reviewId',
  getParentRoute: () => rootRouteImport,
} as any)
const PubsubmissionSubmissionIdRoute =
  PubsubmissionSubmissionIdRouteImport.update({
    id: '/pubsubmission/$submissionId',
    path: '/pubsubmission/$submissionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const MessageActivityIdRoute = MessageActivityIdRouteImport.update({
  id: '/message/$activityId',
  path: '/message/$activityId',
  getParentRoute: () => rootRouteImport,
} as any)
const LeaderboardCompetitionIdRoute =
  LeaderboardCompetitionIdRouteImport.update({
    id: '/leaderboard/$competitionId',
    path: '/leaderboard/$competitionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const DraftsubmissionSubmissionIdRoute =
  DraftsubmissionSubmissionIdRouteImport.update({
    id: '/draftsubmission/$submissionId',
    path: '/draftsubmission/$submissionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const DraftcompetitionCompetitionIdRoute =
  DraftcompetitionCompetitionIdRouteImport.update({
    id: '/draftcompetition/$competitionId',
    path: '/draftcompetition/$competitionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const CompetitionCompetitionIdRoute =
  CompetitionCompetitionIdRouteImport.update({
    id: '/competition/$competitionId',
    path: '/competition/$competitionId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/competition/$competitionId': typeof CompetitionCompetitionIdRoute
  '/draftcompetition/$competitionId': typeof DraftcompetitionCompetitionIdRoute
  '/draftsubmission/$submissionId': typeof DraftsubmissionSubmissionIdRoute
  '/leaderboard/$competitionId': typeof LeaderboardCompetitionIdRoute
  '/message/$activityId': typeof MessageActivityIdRoute
  '/pubsubmission/$submissionId': typeof PubsubmissionSubmissionIdRoute
  '/review/$reviewId': typeof ReviewReviewIdRoute
  '/submission/$submissionId': typeof SubmissionSubmissionIdRoute
  '/uploading/$assetId': typeof UploadingAssetIdRoute
  '/checkedout': typeof CheckedoutIndexRoute
  '/home': typeof HomeIndexRoute
  '/profile': typeof ProfileIndexRoute
  '/record': typeof RecordIndexRoute
  '/subscribe': typeof SubscribeIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/competition/$competitionId': typeof CompetitionCompetitionIdRoute
  '/draftcompetition/$competitionId': typeof DraftcompetitionCompetitionIdRoute
  '/draftsubmission/$submissionId': typeof DraftsubmissionSubmissionIdRoute
  '/leaderboard/$competitionId': typeof LeaderboardCompetitionIdRoute
  '/message/$activityId': typeof MessageActivityIdRoute
  '/pubsubmission/$submissionId': typeof PubsubmissionSubmissionIdRoute
  '/review/$reviewId': typeof ReviewReviewIdRoute
  '/submission/$submissionId': typeof SubmissionSubmissionIdRoute
  '/uploading/$assetId': typeof UploadingAssetIdRoute
  '/checkedout': typeof CheckedoutIndexRoute
  '/home': typeof HomeIndexRoute
  '/profile': typeof ProfileIndexRoute
  '/record': typeof RecordIndexRoute
  '/subscribe': typeof SubscribeIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/competition/$competitionId': typeof CompetitionCompetitionIdRoute
  '/draftcompetition/$competitionId': typeof DraftcompetitionCompetitionIdRoute
  '/draftsubmission/$submissionId': typeof DraftsubmissionSubmissionIdRoute
  '/leaderboard/$competitionId': typeof LeaderboardCompetitionIdRoute
  '/message/$activityId': typeof MessageActivityIdRoute
  '/pubsubmission/$submissionId': typeof PubsubmissionSubmissionIdRoute
  '/review/$reviewId': typeof ReviewReviewIdRoute
  '/submission/$submissionId': typeof SubmissionSubmissionIdRoute
  '/uploading/$assetId': typeof UploadingAssetIdRoute
  '/checkedout/': typeof CheckedoutIndexRoute
  '/home/': typeof HomeIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/record/': typeof RecordIndexRoute
  '/subscribe/': typeof SubscribeIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/competition/$competitionId'
    | '/draftcompetition/$competitionId'
    | '/draftsubmission/$submissionId'
    | '/leaderboard/$competitionId'
    | '/message/$activityId'
    | '/pubsubmission/$submissionId'
    | '/review/$reviewId'
    | '/submission/$submissionId'
    | '/uploading/$assetId'
    | '/checkedout'
    | '/home'
    | '/profile'
    | '/record'
    | '/subscribe'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/competition/$competitionId'
    | '/draftcompetition/$competitionId'
    | '/draftsubmission/$submissionId'
    | '/leaderboard/$competitionId'
    | '/message/$activityId'
    | '/pubsubmission/$submissionId'
    | '/review/$reviewId'
    | '/submission/$submissionId'
    | '/uploading/$assetId'
    | '/checkedout'
    | '/home'
    | '/profile'
    | '/record'
    | '/subscribe'
  id:
    | '__root__'
    | '/'
    | '/competition/$competitionId'
    | '/draftcompetition/$competitionId'
    | '/draftsubmission/$submissionId'
    | '/leaderboard/$competitionId'
    | '/message/$activityId'
    | '/pubsubmission/$submissionId'
    | '/review/$reviewId'
    | '/submission/$submissionId'
    | '/uploading/$assetId'
    | '/checkedout/'
    | '/home/'
    | '/profile/'
    | '/record/'
    | '/subscribe/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CompetitionCompetitionIdRoute: typeof CompetitionCompetitionIdRoute
  DraftcompetitionCompetitionIdRoute: typeof DraftcompetitionCompetitionIdRoute
  DraftsubmissionSubmissionIdRoute: typeof DraftsubmissionSubmissionIdRoute
  LeaderboardCompetitionIdRoute: typeof LeaderboardCompetitionIdRoute
  MessageActivityIdRoute: typeof MessageActivityIdRoute
  PubsubmissionSubmissionIdRoute: typeof PubsubmissionSubmissionIdRoute
  ReviewReviewIdRoute: typeof ReviewReviewIdRoute
  SubmissionSubmissionIdRoute: typeof SubmissionSubmissionIdRoute
  UploadingAssetIdRoute: typeof UploadingAssetIdRoute
  CheckedoutIndexRoute: typeof CheckedoutIndexRoute
  HomeIndexRoute: typeof HomeIndexRoute
  ProfileIndexRoute: typeof ProfileIndexRoute
  RecordIndexRoute: typeof RecordIndexRoute
  SubscribeIndexRoute: typeof SubscribeIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscribe/': {
      id: '/subscribe/'
      path: '/subscribe'
      fullPath: '/subscribe'
      preLoaderRoute: typeof SubscribeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/record/': {
      id: '/record/'
      path: '/record'
      fullPath: '/record'
      preLoaderRoute: typeof RecordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/': {
      id: '/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home/': {
      id: '/home/'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkedout/': {
      id: '/checkedout/'
      path: '/checkedout'
      fullPath: '/checkedout'
      preLoaderRoute: typeof CheckedoutIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/uploading/$assetId': {
      id: '/uploading/$assetId'
      path: '/uploading/$assetId'
      fullPath: '/uploading/$assetId'
      preLoaderRoute: typeof UploadingAssetIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/submission/$submissionId': {
      id: '/submission/$submissionId'
      path: '/submission/$submissionId'
      fullPath: '/submission/$submissionId'
      preLoaderRoute: typeof SubmissionSubmissionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/review/$reviewId': {
      id: '/review/$reviewId'
      path: '/review/$reviewId'
      fullPath: '/review/$reviewId'
      preLoaderRoute: typeof ReviewReviewIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pubsubmission/$submissionId': {
      id: '/pubsubmission/$submissionId'
      path: '/pubsubmission/$submissionId'
      fullPath: '/pubsubmission/$submissionId'
      preLoaderRoute: typeof PubsubmissionSubmissionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/message/$activityId': {
      id: '/message/$activityId'
      path: '/message/$activityId'
      fullPath: '/message/$activityId'
      preLoaderRoute: typeof MessageActivityIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/leaderboard/$competitionId': {
      id: '/leaderboard/$competitionId'
      path: '/leaderboard/$competitionId'
      fullPath: '/leaderboard/$competitionId'
      preLoaderRoute: typeof LeaderboardCompetitionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/draftsubmission/$submissionId': {
      id: '/draftsubmission/$submissionId'
      path: '/draftsubmission/$submissionId'
      fullPath: '/draftsubmission/$submissionId'
      preLoaderRoute: typeof DraftsubmissionSubmissionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/draftcompetition/$competitionId': {
      id: '/draftcompetition/$competitionId'
      path: '/draftcompetition/$competitionId'
      fullPath: '/draftcompetition/$competitionId'
      preLoaderRoute: typeof DraftcompetitionCompetitionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/competition/$competitionId': {
      id: '/competition/$competitionId'
      path: '/competition/$competitionId'
      fullPath: '/competition/$competitionId'
      preLoaderRoute: typeof CompetitionCompetitionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CompetitionCompetitionIdRoute: CompetitionCompetitionIdRoute,
  DraftcompetitionCompetitionIdRoute: DraftcompetitionCompetitionIdRoute,
  DraftsubmissionSubmissionIdRoute: DraftsubmissionSubmissionIdRoute,
  LeaderboardCompetitionIdRoute: LeaderboardCompetitionIdRoute,
  MessageActivityIdRoute: MessageActivityIdRoute,
  PubsubmissionSubmissionIdRoute: PubsubmissionSubmissionIdRoute,
  ReviewReviewIdRoute: ReviewReviewIdRoute,
  SubmissionSubmissionIdRoute: SubmissionSubmissionIdRoute,
  UploadingAssetIdRoute: UploadingAssetIdRoute,
  CheckedoutIndexRoute: CheckedoutIndexRoute,
  HomeIndexRoute: HomeIndexRoute,
  ProfileIndexRoute: ProfileIndexRoute,
  RecordIndexRoute: RecordIndexRoute,
  SubscribeIndexRoute: SubscribeIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
